/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-04 20:19:45
 * @LastEditTime: 2020-08-11 11:47:51
 * @Description: 母液配方api
 */
import axios from '@/utils/axios'

export const getRecipeSemis = (payload) => {
    return axios.get('/recipeSemi', {
        params: payload
    })
}

export const getRecipeSemisById = (id) => {
    return axios.get(`/recipeSemi/${id}`)
}

export const createRecipeSemi = (data) => {
    return axios.post('/recipeSemi', data)
}

export const updateRecipeSemi = (id, data) => {
    return axios.put(`/recipeSemi/${id}`, data);
}